<app-breadcrumb [breadcrumb]="'privacy-policy'" [title]="'Privacy-Policy'"></app-breadcrumb>
<!-- about section start -->
<div class="about-page  section-b-space">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <h4>Privacy Notice</h4>
                <ol class="privacy-policies" type="1">
                    <li>
                        <b>Giftoholics Privacy Terms</b> <br/>
                        <p>
                            Giftoholics recognize and respect the importance of maintaining the privacy of our
                            customers. That is why we have established this Privacy Policy as a result. The purpose of
                            this Privacy Policy is to inform you of:
                        </p>
                        <ul class="list-items">
                            <li>
                                The personal information we may collect from you when you visit our Website, respond to
                                our emails, place orders via mail, or social media applications (such as our Facebook
                                and Instagram) or phone,
                            </li>
                            <li>
                                Why we gather information from you,
                            </li>
                            <li>
                                What information do we gather,
                            </li>
                            <li>
                                How we collect it,
                            </li>
                            <li>
                                How we use it, and
                            </li>
                            <li>
                                The choices you have regarding our use of personal information you have provided.
                            </li>
                        </ul>
                    </li>
                    <li>
                        <b>Why do we gather information?</b> <br/>
                        <p>
                            Giftoholics gathers personal information to improve our products and customer service, to
                            communicate with you, to process your orders, to provide an enhanced and more personalized
                            shopping experience, and to inform you of special offers and discounts from us.
                        </p>
                    </li>
                    <li>
                        <b>What information do we gather?</b> <br/>
                        <p>
                            We collect information through our website, emails, phone, and social media applications
                            (such as our Facebook or Instagram App) when you place an order.
                            Depending on how you interact with us, we collect some or all of the following types of
                            information:
                        </p>
                        <ul class="list-items">
                            <li>your name, address, phone number, email address,</li>
                            <li>billing information (credit/debit card number, expiration date, alternate or additional
                                billing information, and billing address),
                            </li>
                            <li>gender and birth date, if you choose, or are otherwise required to, enter such
                                information, interests,
                            </li>
                            <li>products purchased and occasion type (for example, Mother's Day), ● Message and gift
                                recipients' names, photographs, addresses, telephone numbers, and email addresses.
                            </li>
                        </ul>
                    </li>
                    <li>
                        <b>How we use the information we collect?</b> <br/>
                        <p>
                            Giftoholics use the information we collect to communicate with you, process your orders,
                            improve our products and services, conduct research, provide an enhanced and more
                            personalized shopping experience, to inform you of offers and discounts from Giftoholics.
                            Without your consent, we do not make your personal information available to "third parties".
                            For example, we may make your postal address available to third parties for delivery
                            purposes, however, we would not share your email address or any other information with a
                            third party without your consent.
                        </p>
                        <p>
                            We reserve the right to disclose information you provide to us as required by law, in
                            response to legal process and law enforcement requests.
                        </p>
                    </li>
                    <li>
                        <b>Correction</b>
                        <p>
                            If you would like to update or correct information previously provided to us, please send an
                            e-mail at <a
                                href="mailto:giftoholics.handmade@gmail.com">giftoholics.handmade@gmail.com</a> with
                            your new information, including your complete
                            name, postal address, and email address.
                        </p>
                    </li>
                    <li>
                        <b>Agreement</b> <br/>
                        <p>By using the Services, you agree to be legally bound and to abide by the revised Privacy
                            Policy and Terms of Use, of which this policy is a part.</p>
                    </li>
                    <li>
                        <b>Your Comments</b> <br/>
                        <p>
                            Giftoholics welcomes feedback concerning this Privacy Policy. Please send your comments and
                            questions to <a
                                href="mailto:giftoholics.handmade@gmail.com">giftoholics.handmade@gmail.com</a>.
                        </p>
                    </li>
                </ol>
            </div>
        </div>
    </div>
</div>
